import SectionJobsSidebar1 from "../../sections/jobs/sidebar/section-jobs-sidebar1";
import SectionJobsList from "../../sections/jobs/section-jobs-list";
import SectionRecordsFilter from "../../sections/common/section-records-filter";
import { useMemo, useState } from "react";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { loadScript } from "../../../../../globals/constants";
import { jobService } from "../../../../../services/job-service";

function JobsListPage() {
    const [total, setTotal] = useState(0);
    const [searchParams, setSearchParams] = useSearchParams();
    const [categories, setCategories] = useState([]);
    const [filters, setFilters] = useState({
        keyword: searchParams.get("keyword") || "",
        location: searchParams.get("location") || "",
        type: searchParams.get("type") || "",
        category: searchParams.get("category") || "",
        subcategory: searchParams.get("subcategory") || ""
    });

    const _filterConfig = useMemo(() => ({
        prefix: "Showing",
        type: "jobs",
        total: String(total),
        showRange: false,
        showingUpto: ""
    }), [total]);

    useEffect(()=>{
        loadScript("js/custom.js");
        jobService.jobCategories()
            .then(data => setCategories(data.categories || []))
            .catch(err => console.error(err));
    }, []);

    useEffect(() => {
        setFilters({
            keyword: searchParams.get("keyword") || "",
            location: searchParams.get("location") || "",
            type: searchParams.get("type") || "",
            category: searchParams.get("category") || "",
            subcategory: searchParams.get("subcategory") || ""
        });
    }, [searchParams]);

    const update = (event) => {
        setFilters({ ...filters, [event.target.name]: event.target.value });
    };

    const submit = (event) => {
        event.preventDefault();
        const next = {};
        Object.entries(filters).forEach(([key, value]) => {
            if (value) next[key] = value;
        });
        setSearchParams(next);
    };

    return (
        <>
            <div className="section-full p-t120  p-b90 site-bg-white">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-12 rightSidebar">
                            <SectionJobsSidebar1 />
                        </div>
                        <div className="col-lg-8 col-md-12">
                            <form onSubmit={submit} className="m-b30">
                                <div className="row g-2">
                                    <div className="col-md-4 m-b10">
                                        <input className="form-control" name="keyword" value={filters.keyword} onChange={update} placeholder="Job title or keyword" />
                                    </div>
                                    <div className="col-md-4 m-b10">
                                        <input className="form-control" name="location" value={filters.location} onChange={update} placeholder="Location" />
                                    </div>
                                    <div className="col-md-4 m-b10">
                                        <select className="form-control" name="type" value={filters.type} onChange={update}>
                                            <option value="">All Job Types</option>
                                            <option value="Freelance">Freelance</option>
                                            <option value="Full Time">Full Time</option>
                                            <option value="Internship">Internship</option>
                                            <option value="Part Time">Part Time</option>
                                            <option value="Temporary">Temporary</option>
                                            <option value="Volunteer">Volunteer</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4 m-b10">
                                        <select className="form-control" name="category" value={filters.category} onChange={(e) => setFilters({ ...filters, category: e.target.value, subcategory: "" })}>
                                            <option value="">All Categories</option>
                                            {categories.filter(c => !c.parent_id).map(c => (
                                                <option key={c.id} value={c.name}>{c.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-4 m-b10">
                                        <select className="form-control" name="subcategory" value={filters.subcategory} onChange={update}>
                                            <option value="">All Subcategories</option>
                                            {categories.filter(c => c.parent_id && categories.find(p => p.id === c.parent_id)?.name === filters.category).map(c => (
                                                <option key={c.id} value={c.name}>{c.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-4 m-b10">
                                        <button className="site-button w-100" type="submit">Search Jobs</button>
                                    </div>
                                </div>
                            </form>
                            {/*Filter Short By*/}
                            <SectionRecordsFilter _config={_filterConfig} />
                            <SectionJobsList onLoaded={setTotal} />
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default JobsListPage;
